module.exports = __webpack_public_path__ + "img/dante-levels.60d416d8.jpg";